<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="validate">
        <div class="row">
          <div class="col-12">
            <ValidationProvider
              name="courseName"
              rules="required|max:255"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="courseName"
                :error="failed ? 'The Course Name is required': null"
                :has-success="passed"
                required
                label="Course Name"
                placeholder="Course Name"
                max-length="255"
                v-model="courseSetupInfo.CourseName"
              />
            </ValidationProvider>
            <ValidationProvider
              name="hostingCouncil"
              rules="required"
            >
              <fg-input
                slot-scope="{ errors }"
                :error="errors[0] ? 'The Host Council is required.': ''"
              >
                <label>Host Council <span class="text-danger">*</span></label>
                <el-select
                  class="select-default2"
                  ref="councilSelector"
                  size="large"
                  name="hostingCouncil"
                  placeholder=""
                  v-model="courseSetupInfo.HostingCouncil"
                >
                  <el-option
                    v-for="c in councils"
                    class="select-default2"
                    :value="c.Id"
                    :label="c.CouncilName"
                    :key="c.Id"
                  />
                </el-select>
              </fg-input>
            </ValidationProvider>
            <fg-input
              name="curriculumYear"
              readonly
              title="Curriculum Year"
              label="Curriculum Year"
              type="number"
              placeholder="Curriculum Year"
              v-model="courseSetupInfo.CurriculumYear"
            />
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import courseApi from '@/services/api/course.js'

export default {
  name: 'CourseCreationCourseInfo',
  data: function () {
    return {
      courseSetupInfo: {
        CourseName: null,
        HostingCouncil: null,
        HostingCouncilName: null,
        CurriculumYear: 2020,
        ImportFromTemplate: true
      },
      councils: [],
      tempHolding: null
    }
  },
  watch: {
    'courseSetupInfo.HostingCouncil': function (newValue, oldValue) {
      if (newValue !== undefined && newValue !== null) {
        this.$nextTick(function () {
          this.tempHolding = this.$refs.councilSelector.selectedLabel
          this.courseSetupInfo.HostingCouncilName = this.$refs.councilSelector.selectedLabel
        })
      }
    }
  },
  created () {
    this.councils = this.getCouncils()
  },
  methods: {
    validate: function () {
      return this.$refs.form.validate().then(res => {
        if (res) {
          this.$emit('on-validated', res, 'courseSetupInfo', this.courseSetupInfo)
        }
        return res
      })
    },
    getCouncils: function () {
      courseApi.getCouncilLookups()
        .then(x => {
          this.councils = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
